module.exports = __webpack_public_path__ + "img/Dental3d_4.49a1f44d.png";